import * as React from "react";
function SvgIconArrowRightBlack(props: React.SVGProps<SVGSVGElement>) {
  return <svg id="f2f4178d-143c-4ad8-bf84-8d22c2d4c090" data-name="icon-arrow-right-black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12.56" {...props}><title>{"icon-arrow-right-black"}</title><path d="M4.19,6.33,1.05,1.86A14.19,14.19,0,0,0,0,.46L.81,0,3.52,2.74C4.68,3.9,5.84,5,7,6.12v.42L3.13,10.27c-.81.81-1.62,1.55-2.32,2.29L0,12Z" style={{
      fill: "#222"
    }} /></svg>;
}
export default SvgIconArrowRightBlack;